<template>
	<div class="user-management-container">
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span>人员管理</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="handleAdd">
					添加人员
				</el-button>
			</div>

			<!-- 搜索和筛选区域 -->
			<el-form :inline="true" :model="searchForm" class="search-form">
				<el-form-item label="关键词">
					<el-input v-model="searchForm.keyword" placeholder="姓名/用户名/电话" clearable @clear="handleSearch"
						@keyup.enter.native="handleSearch"></el-input>
				</el-form-item>
				<el-form-item label="角色">
					<el-select v-model="searchForm.role" placeholder="全部角色" clearable @change="handleSearch">
						<el-option label="普通用户" :value="1"></el-option>
						<el-option label="管理员" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态">
					<el-select v-model="searchForm.status" placeholder="全部状态" clearable @change="handleSearch">
						<el-option label="启用" :value="1"></el-option>
						<el-option label="禁用" :value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleSearch">搜索</el-button>
				</el-form-item>
			</el-form>

			<!-- 人员列表表格 -->
			<el-table :data="userList" border style="width: 100%" v-loading="loading">
				<el-table-column prop="id" label="ID" width="60"></el-table-column>
				<el-table-column label="头像" width="80">
					<template slot-scope="scope">
						<el-avatar :size="40" :src="scope.row.avatarUrl">
							{{ scope.row.real_name ? scope.row.real_name.charAt(0) : '' }}
						</el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="username" label="用户名"></el-table-column>
				<el-table-column prop="real_name" label="姓名"></el-table-column>
				<el-table-column prop="position" label="职位" width="120"></el-table-column>
				<el-table-column prop="phone" label="电话" width="120"></el-table-column>
				<el-table-column prop="email" label="邮箱" width="180"></el-table-column>
				<el-table-column label="角色" width="140" align="center">
					<template slot-scope="scope">
						<el-tag :type="scope.row.role === 2 ? 'danger' : ''">
							{{ scope.row.role === 2 ? '管理员' : '普通用户' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="140" align="center">
					<template slot-scope="scope">
						<el-tag :type="scope.row.status ? 'success' : 'danger'">
							{{ scope.row.status ? '启用' : '禁用' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="220" fixed="right">
					<template slot-scope="scope">
						<el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="mini" :type="scope.row.status ? 'warning' : 'success'"
							@click="handleChangeStatus(scope.row.id, scope.row.status ? 0 : 1)">
							{{ scope.row.status ? '禁用' : '启用' }}
						</el-button>
						<el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页组件 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination">
			</el-pagination>
		</el-card>

		<!-- 添加/编辑对话框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" @close="resetForm"
			:close-on-click-modal="false">
			<el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
				<el-form-item label="用户名" prop="username">
					<el-input v-model="form.username" :disabled="isEdit"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password" v-if="!isEdit">
					<el-input v-model="form.password" type="password" show-password></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="new_password" v-else>
					<el-input v-model="form.new_password" type="password" placeholder="留空则不修改" show-password></el-input>
				</el-form-item>
				<el-form-item label="真实姓名" prop="real_name">
					<el-input v-model="form.real_name"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="phone">
					<el-input v-model="form.phone"></el-input>
				</el-form-item>
				<el-form-item label="电子邮箱" prop="email">
					<el-input v-model="form.email"></el-input>
				</el-form-item>
				<el-form-item label="职位" prop="position">
					<el-input v-model="form.position"></el-input>
				</el-form-item>
				<el-form-item label="头像" prop="avatarUrl">
					<el-upload class="avatar-uploader" action="http://service.fossnet.cn/api/upload.php"
						:show-file-list="false" :on-success="handleUploadSuccess" :before-upload="beforeUpload">
						<img v-if="form.avatarUrl" :src="form.avatarUrl" class="avatar" />
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="角色" prop="role">
					<el-radio-group v-model="form.role">
						<el-radio :label="1">普通用户</el-radio>
						<el-radio :label="2">管理员</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="状态" prop="status">
					<el-switch v-model="form.status" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		apiBaseUrl
	} from '@/config';

	export default {
		data() {
			return {
				loading: false,
				userList: [],
				companyList: [],
				searchForm: {
					keyword: '',
					company_id: '',
					role: '',
					status: ''
				},
				pagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				dialogVisible: false,
				dialogTitle: '添加人员',
				form: {
					id: '',
					username: '',
					password: '',
					new_password: '',
					real_name: '',
					phone: '',
					email: '',
					position: '',
					avatarUrl: '',
					role: 1,
					status: 1
				},
				rules: {
					username: [{
							required: true,
							message: '请输入用户名',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 20,
							message: '长度在 3 到 20 个字符',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
					real_name: [{
						required: true,
						message: '请输入真实姓名',
						trigger: 'blur'
					}],
					phone: [{
						pattern: /^1[3-9]\d{9}$/,
						message: '请输入正确的手机号码',
						trigger: 'blur'
					}],
					email: [{
						type: 'email',
						message: '请输入正确的邮箱地址',
						trigger: 'blur'
					}]
				},
				isEdit: false,
				uploadUrl: `${apiBaseUrl}/api/upload.php`
			};
		},
		created() {
			this.fetchUserList();
		},
		methods: {
			// 获取用户列表
			async fetchUserList() {
				this.loading = true;
				try {
					const params = {
						action: 'list',
						page: this.pagination.currentPage,
						pageSize: this.pagination.pageSize,
						...this.searchForm
					};

					const response = await fetch(`${apiBaseUrl}/users.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(params),
					});

					const data = await response.json();

					if (data.success) {
						this.userList = data.data;
						this.pagination.total = parseInt(data.total);
					} else {
						throw new Error(data.message || '获取用户列表失败');
					}
				} catch (error) {
					this.$message.error(error.message);
				} finally {
					this.loading = false;
				}
			},

			// 搜索
			handleSearch() {
				this.pagination.currentPage = 1;
				this.fetchUserList();
			},

			// 分页大小改变
			handleSizeChange(val) {
				this.pagination.pageSize = val;
				this.fetchUserList();
			},

			// 当前页改变
			handleCurrentChange(val) {
				this.pagination.currentPage = val;
				this.fetchUserList();
			},

			// 添加人员
			handleAdd() {
				this.dialogTitle = '添加人员';
				this.isEdit = false;
				this.resetForm();
				this.dialogVisible = true;
			},

			// 编辑人员
			handleEdit(row) {
				this.dialogTitle = '编辑人员';
				this.isEdit = true;
				this.form = {
					id: row.id,
					company_id: row.company_id,
					username: row.username,
					password: '',
					new_password: '',
					real_name: row.real_name,
					phone: row.phone,
					email: row.email,
					position: row.position,
					avatarUrl: row.avatarUrl,
					role: row.role,
					status: row.status
				};
				this.dialogVisible = true;
			},

			// 提交表单
			async submitForm() {
				this.$refs.form.validate(async (valid) => {
					if (!valid) return;

					try {
						let params = {
							...this.form
						};
						if (this.isEdit) {
							params.action = 'update';
							// 如果不修改密码，移除密码字段
							if (!params.new_password) {
								delete params.new_password;
								delete params.password;
							} else {
								params.password = params.new_password;
								delete params.new_password;
							}
						} else {
							params.action = 'add';
						}

						const response = await fetch(`${apiBaseUrl}/users.php`, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify(params),
						});

						const data = await response.json();

						if (data.success) {
							this.$message.success(this.isEdit ? '修改成功' : '添加成功');
							this.dialogVisible = false;
							this.fetchUserList();
						} else {
							throw new Error(data.message || (this.isEdit ? '修改失败' : '添加失败'));
						}
					} catch (error) {
						this.$message.error(error.message);
					}
				});
			},

			// 改变状态
			async handleChangeStatus(id, status) {
				try {
					await this.$confirm(`确定要${status ? '启用' : '禁用'}该用户吗?`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});

					const response = await fetch(`${apiBaseUrl}/users.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							action: 'change_status',
							id,
							status
						}),
					});

					const data = await response.json();

					if (data.success) {
						this.$message.success('状态更新成功');
						this.fetchUserList();
					} else {
						throw new Error(data.message || '状态更新失败');
					}
				} catch (error) {
					if (error !== 'cancel') {
						this.$message.error(error.message);
					}
				}
			},

			// 删除人员
			async handleDelete(id) {
				try {
					await this.$confirm('确定要删除该用户吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});

					const response = await fetch(`${apiBaseUrl}/users.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							action: 'delete',
							id
						}),
					});

					const data = await response.json();

					if (data.success) {
						this.$message.success('删除成功');
						this.fetchUserList();
					} else {
						throw new Error(data.message || '删除失败');
					}
				} catch (error) {
					if (error !== 'cancel') {
						this.$message.error(error.message);
					}
				}
			},

			// 重置表单
			resetForm() {
				this.form = {
					id: '',
					company_id: '',
					username: '',
					password: '',
					new_password: '',
					real_name: '',
					phone: '',
					email: '',
					position: '',
					avatarUrl: '',
					role: 1,
					status: 1
				};
				if (this.$refs.form) {
					this.$refs.form.resetFields();
				}
			},

			// 上传成功处理
			handleUploadSuccess(response) {
				if (response.success) {
					this.form.avatarUrl = apiBaseUrl + '/' + response.data.path;
					this.$refs.form.validateField('avatarUrl');
				} else {
					this.$message.error(response.message || '上传失败');
				}
			},

			// 上传前校验
			beforeUpload(file) {
				const isImage = file.type.startsWith('image/');
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isImage) {
					this.$message.error('上传文件只能是图片格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isImage && isLt2M;
			}
		}
	};
</script>

<style scoped>
	.user-management-container {
		/* padding: 20px; */
	}

	.search-form {
		margin-bottom: 20px;
	}

	.pagination {
		margin-top: 20px;
		text-align: right;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>